/**
 * TGH Senior Center — Video modal
 * Any [data-tgh-video="URL"] opens the shared <dialog data-tgh-modal>.
 * YouTube / Vimeo URLs are embedded via iframe, direct files (.mp4/.webm) via <video>.
 * The player is destroyed on close so playback always stops.
 */
(function () {
  'use strict';

  function isFile(url) { return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url); }

  function withAutoplay(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&rel=0';
  }

  function init() {
    var modal = document.querySelector('[data-tgh-modal]');
    if (!modal || modal.dataset.tghReady || typeof modal.showModal !== 'function') return;
    modal.dataset.tghReady = '1';

    var frame = modal.querySelector('[data-tgh-modal-frame]');
    var lastTrigger = null;

    function open(url) {
      var player;
      if (isFile(url)) {
        player = document.createElement('video');
        player.src = url;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
      } else {
        player = document.createElement('iframe');
        player.src = withAutoplay(url);
        player.title = 'Video';
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
      }
      frame.replaceChildren(player);
      modal.showModal();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tgh-video]');
      if (!trigger) return;
      event.preventDefault();
      lastTrigger = trigger;
      open(trigger.getAttribute('data-tgh-video'));
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-tgh-modal-close]')) modal.close();
    });

    modal.addEventListener('close', function () {
      frame.replaceChildren();
      if (lastTrigger) lastTrigger.focus();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/video-modal.js